﻿import {DateTime} from "@2d-front-monorepo/core";
import IDateRange from "../interfaces/IDateRange";
import {SelectedParkingPrebookingAvailabilityEntry} from "../types/ParkingPrebookingAvailabilityEntry";

export class MultiOperationSegment implements IDateRange {
	private readonly _startDate: DateTime;
	private readonly _endDate: DateTime;

	constructor(startDate: DateTime, endDate: DateTime) {
		this._startDate = startDate;
		this._endDate = endDate;
	}

	get startDate(): DateTime {
		return this._startDate;
	}

	get endDate(): DateTime {
		return this._endDate;
	}

	toPrebookingEntry(): SelectedParkingPrebookingAvailabilityEntry {
		return {
			startDate: this._startDate,
			endDate: this._endDate
		}
	}
}
